import AdaApi from '../api/adaAPI';
import Preloader from '../../webparts/Preloader';
import Bowser from 'bowser';
import { BROWSER_MAP } from 'bowser/src/constants.js';

const SiteHelper = {};

SiteHelper.isIntranetSite = () => {
    const result = window.location.host.indexOf('.na.') > 0;
    return result;
};

SiteHelper.tryRedirectToMemberHome = () => {
    const api = new AdaApi();

    //if token exists
    const token = window.hubCookie.getToken();
    if (!token) {
        return;
    }

    const loader = new Preloader();
    loader.show();

    const hideLoader = () => {
        loader.hide();
    };

    //validate the token
    api.validate()
        .then(response => {
            window.location = window.hubConfig.defaultMemberUrl;
        })
        .catch(error => {
            window.hubCookie.unset();
            hideLoader();
        });
};

SiteHelper.isSafariUser = () => {
    let isSafari = false;
    try {
        //try to identify the browser. If it's safari, the virtual meeting link should go to mediasite
        const browser = Bowser.getParser(window.navigator.userAgent);
        isSafari = browser.getBrowserName() === BROWSER_MAP.safari;
    } catch (err) {
        console.error(err);
    }
    return isSafari;
};

export { SiteHelper };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/SiteHelper.js